import { render, staticRenderFns } from "./communitySVG.vue?vue&type=template&id=6720c591"
import script from "./communitySVG.vue?vue&type=script&lang=js"
export * from "./communitySVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports